// extracted by mini-css-extract-plugin
module.exports = {"collapsibleTitle":"CashbackDeclineReasons_collapsibleTitle__1meD7","list":"CashbackDeclineReasons_list__nMVfE"};